import { ProjectReleaseContextProvider } from "./context/project_release_context";
import ProjectReleaseLayout from "./project_release_layout";

const ProjectReleasePage = () => {
  return (
    <ProjectReleaseContextProvider>
      <ProjectReleaseLayout />
    </ProjectReleaseContextProvider>
  );
};

export default ProjectReleasePage;